import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 17 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 15\" id=\"icon-arrow-left\"><path d=\"M4.573 8.652l4.151 4.247c.39.4.392 1.049.004 1.45a.976.976 0 01-1.408.005L.79 7.672 7.316.952a.976.976 0 011.41 0c.388.4.388 1.05 0 1.45l-4.129 4.25H15.98c.447 0 .81.448.81 1s-.363 1-.81 1H4.573z\" fill=\"#493E54\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol